import React from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

function JobDetailsPage(props) {
    var { t } = useTranslation();
    var navigate = useNavigate();
    var location = useLocation();
    var { id } = useParams();

    // Job can be passed via router state
    var job = location.state ? location.state.job : null;

    // Fallback: if no state, props.jobs can be searched
    if (!job && props.jobs) {
        job = props.jobs.find(function (item) { return String(item.id) === id; });
    }

    if (!job) {
        return <div className="uk-container uk-margin-large-top">{t("Job not found")}</div>;
    }

    return (
        <div className="uk-container uk-margin-large-top uk-margin-large-bottom">
            <div className="uk-card uk-card-default uk-box-shadow-medium uk-padding">

                {/* Back button */}
                <button
                    className="uk-button uk-button-text uk-margin-small-bottom"
                    onClick={function () { navigate(-1); }}
                >
                    <span uk-icon="icon: arrow-left"></span> {t("Back")}
                </button>

                <div className="uk-grid-small uk-child-width-1-1 uk-child-width-1-2@m uk-margin" uk-grid="true">

                    {/* Left: Job Image */}
                    <div>
                        <img
                            src={job.image}
                            alt={job.title}
                            className="uk-border-rounded uk-box-shadow-medium"
                            style={{ width: "100%", height: "280px", objectFit: "cover" }}
                        />
                    </div>

                    {/* Right: Title + Description */}
                    <div>
                        {/* Job Title */}
                        <h2 className="uk-heading-line uk-text-bold uk-margin-small-bottom">
                            <span>{job.title}</span>
                        </h2>

                        {/* Job Description */}
                        <p className="uk-text-justify uk-margin-remove-top">
                            {job.description}
                        </p>
                    </div>
                </div>


                {/* Salary and City */}
                <div className="uk-child-width-1-2@s uk-grid-divider uk-grid-small uk-margin-medium-bottom" uk-grid="true">
                    <div>
                        <h4 className="uk-text-bold">{t("Salary")}</h4>
                        <p>{job.salary}</p>
                    </div>
                    <div>
                        <h4 className="uk-text-bold">{t("City")}</h4>
                        <p>{job.city}</p>
                    </div>
                </div>

                {/* Action Buttons */}
                <div className="uk-flex uk-flex-between uk-margin-top">
                    <button className="uk-button uk-button-jai">
                        {t("Apply Now")}
                    </button>
                    <button className="uk-button uk-button-default">
                        <span uk-icon="icon: heart"></span> {t("Save")}
                    </button>
                </div>

            </div>
        </div>
    );
}

export default JobDetailsPage;
